export default {
  attachmentItemComponent: 'attachment-item-pill',
  allowMediaInserter: false,
  allowMention: false,
  allowAttribute: false,
  autoFocusBottomRight: false,
  autoFocusTopLeft: false,
  urlReplacement: false,
  allowButton: false,
  allowSocial: false,
  allowHeading: true,
  allowSubheading: true,
  recoverErrors: true,
  allowEmoji: true,
  allowSavedReplies: true,
  allowMarkdownHeadings: false,
  markdownInlineCode: true,
  stripEmptyTrailingBlocks: true,
  allowImage: false,
  allowVideo: false,
  allowUploads: false
};